import React from 'react';
import PropTypes from 'prop-types';
import { IconSuccess, IconWarning } from '@americanexpress/dls-icons';
import { parseHtml } from '../../utils/util';

/**
 * returns DLS Modal component
 * @param {*} param0
 */
const Modal = ({ modalFields }) => {
  const {
    modalTitle,
    modalHeading,
    modalInfo1,
    modalInfo2,
    modalInfoList,
    isModalCTA,
    isCloseBtn,
    modalType,
    modalCss,
  } = modalFields;
  const titleCss = modalCss && modalCss.titleCss ? modalCss.titleCss : 'fluid text-align-center heading-4';
  const headingCss = modalCss && modalCss.headingCss ? modalCss.headingCss : 'heading-5 margin-3-b text-align-left pad-3-t';
  const info1Css = modalCss && modalCss.info1Css ? modalCss.info1Css : 'heading-4 pad-2-b text-align-center';
  const info2Css = modalCss && modalCss.info2Css ? modalCss.info2Css : 'heading-4 pad-2-b text-align-center';
  return (
    <div className="col-md-12">
      <div className="flex flex-align-center">
        <div className="container">
          <div role="dialog">
            <header className="flex flex-align-center margin-2-t dls-bright-white-bg dls-black">
              { modalTitle && <p className={titleCss}>{ modalTitle }</p> }
              { isCloseBtn
                && (
                <button type="button" className="focus-light" data-dismiss={true} aria-label="Close">
                  <i data-dls-glyph="close" data-dls-glyph-size="lg" aria-label="Close Icon" />
                </button>
                )}
            </header>
            <div className="card col-md-12 pad-1-lr">
              <div className="pad-responsive-lr stack pad-3-tb">
                <div className="text-align-center">
                  {
                    modalType === 'success'
                      ? (
                        <IconSuccess
                          className="dls-color-success"
                          size="lg"
                        />
                      )
                      : (
                        <IconWarning
                          className="dls-color-warning"
                          size="lg"
                        />
                      )
                  }

                </div>
                { modalHeading && <h2 className={headingCss}>{ modalHeading }</h2> }
                { modalInfo1 && <p className={info1Css}>{ parseHtml(modalInfo1) }</p> }
                { modalInfo2 && <p className={info2Css}>{ parseHtml(modalInfo2) }</p> }
                { modalInfoList && (
                  <>
                    {modalInfoList.primaryInfo}
                    <ul className="body-3">
                      {
                        modalInfoList.listNodes.map((node) => (
                          <li key={`fieldId+${node}`}>
                            {parseHtml(node)}
                          </li>
                        ))
                      }
                    </ul>
                  </>
                )}
              </div>
              { isModalCTA
                && (
                  <div className="text-align-right-sm-up text-align-center-sm-down pad border-t pad-4-lr">
                    <button type="button" className="btn">Continue</button>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  modalFields: PropTypes.objectOf(PropTypes.shape),
  modalTitle: PropTypes.string,
  modalHeading: PropTypes.string,
  modalInfo1: PropTypes.string,
  modalInfo2: PropTypes.string,
  isModalCTA: PropTypes.bool,
  isCloseBtn: PropTypes.bool,
};

export default Modal;
